import { ApolloClient, InMemoryCache } from '@apollo/client';
import { HttpLink } from '@apollo/client/link/http';
import envDetect from '@tcc/env-detect';

type Headers = {
  'x-http-caller-id'?: string;
  'x-http-caller-version'?: string;
  'x-data-origin'?: string;
  'x-data-legitimacy'?: string;
};

export const getGqlUri = (isUApi?: boolean) => {
  const isProduction =
    envDetect.getCurrentEnv() === envDetect.environments.PRODUCTION;

  if (isProduction && isUApi) return 'https://uapi.climate.com/app/graphql';
  if (isProduction) return 'https://ol.na.climate.com/v2/graphql';
  if (isUApi) return 'https://uapi.climate.com/app/graphql';
  return '/v2/graphql';
};

const httpLink = (headers?: Headers, isUApi?: boolean) =>
  new HttpLink({
    credentials: 'include',
    uri: getGqlUri(isUApi),
    headers: {
      Accept: 'application/json',
      'x-http-caller-id': 'field-view',
      'x-http-caller-version': process.env.npmPackageVersion || '1.0',
      ...headers,
      ...(localStorage.getItem('auth') &&
        localStorage.getItem('auth') !== 'null' && {
        authorization: localStorage.getItem('auth') || '',
      }),
    },
  });

export function getGraphQlClient({
  headers,
  cache,
  isUApi,
}: { headers?: Headers; cache?: InMemoryCache; isUApi?: boolean } = {}) {
  return new ApolloClient({
    cache: cache || new InMemoryCache(),
    // restLinks should go before httpLink, as httpLink will swallow Headers calls
    link: httpLink(headers, isUApi),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
      },
      query: {},
    },
  });
}
